var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-6"},[_c('FulfillOrders')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }